import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, galleryImages } from '../../data/companyData';

export default class ProjectFour extends React.Component {
    componentDidMount() {

        const $ = window.$;
        
        if ($(".img-popup").length) {
            var groups = {};
            $(".img-popup").each(function () {
              var id = parseInt($(this).attr("data-group"), 10);
        
              if (!groups[id]) {
                groups[id] = [];
              }
        
              groups[id].push(this);
            });
        
            $.each(groups, function () {
              $(this).magnificPopup({
                type: "image",
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: {
                  enabled: true,
                },
              });
            });
        }
          
    }
    render(){
        return (
            <>
                <section className="project-one-sec project-one-sec--three">
                    <div className="container">
                        <div className="row">
                            {galleryImages.map((item, index) => (
                                <div className="col-xl-4 col-lg-4" key={item.src}>
                                    <div className="project-one__single wow fadeInUp" data-wow-delay={`${index * 50}ms`} data-wow-duration="1500ms">
                                        <div className="project-one__single-img">
                                            <div className="inner">
                                                <img src={assetPath(item.src)} alt={item.title} />
                                                <div className="project-one__link">
                                                    <a className="img-popup" href={assetPath(item.src)}>
                                                        <span className="icon-plus-sign"></span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content-box">
                                                <h2><Link to={process.env.PUBLIC_URL + `/gallery`}>{item.title}</Link></h2>
                                                <p>{item.category}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
